module.exports = __webpack_public_path__ + "img/us.67b26caa.svg";